import { defineMessages } from '@alltrails/shared/react-intl';

const COMMUNITY_CONNECT = defineMessages({
  FOLLOW: {
    defaultMessage: 'Follow'
  },
  FOLLOW_BACK: {
    defaultMessage: 'Follow back'
  },
  BLOCK: {
    defaultMessage: 'Block'
  },
  UNFOLLOW: {
    defaultMessage: 'Unfollow'
  },
  REQUESTED: {
    defaultMessage: 'Requested'
  },
  UNBLOCK: {
    defaultMessage: 'Unblock'
  },
  BLOCKING: {
    defaultMessage: 'Blocking'
  },
  UNBLOCKING: {
    defaultMessage: 'Unblocking'
  }
});

export default COMMUNITY_CONNECT;
